import { Link } from 'react-router-dom';
import { To } from 'history';

// material-ui
import ButtonBase from '@mui/material/ButtonBase';
import { SxProps } from '@mui/system';

// project-imports
import Logo from './LogoMain';
import LogoIcon from './LogoIcon';
import LogoNrct from '../../../assets/images/logo-nrct.png';
import LogoMain from '../../../assets/images/logo.png';

import useAuth from '@/hooks/useAuth';
import { APP_DEFAULT_PATH } from '@/config';
import { Box, Stack, Typography } from '@mui/material';

interface Props {
  isIcon?: boolean;
  sx?: SxProps;
  to?: To;
}

// ==============================|| MAIN LOGO ||============================== //

export default function LogoSection({ isIcon, sx, to }: Props) {
  const { isLoggedIn } = useAuth();

  return (
    <ButtonBase disableRipple {...(isLoggedIn && { component: Link, to: !to ? APP_DEFAULT_PATH : to, sx })}>
      {/* {isIcon ? <LogoIcon /> : <Logo />} */}
      {isIcon ? (
        <Box>
          <img src={LogoMain} alt="" width={40} />
        </Box>
      ) : (
        <Box>
          <Stack direction={'row'} spacing={1} justifyContent="center" alignContent={'center'} alignItems={'center'}>
            <img src={LogoMain} alt="" width={200} />
            <Stack direction={'column'}>
              <Typography color={'#09529D'} sx={{ fontWeight: 700 }}></Typography>
            </Stack>
          </Stack>
        </Box>
      )}
    </ButtonBase>
  );
}
